// =============================================================
// lightbox.js — Masonry click -> opens fullscreen Slideshow.
// One open() session manages its own listeners and cleans them
// up properly on close (Esc, backdrop, X-button).
// =============================================================
import { getSlideshow } from "./slideshow.js";

export function initLightbox(root = document) {
  // Pointer + keyboard activation
  const onActivate = (e, target) => {
    const item = target.closest(".masonry-item");
    if (!item) return;

    const section = item.closest(".slide");
    if (!section) return;
    const lb = section.querySelector(".gallery-lightbox");
    if (!lb) return;
    const ssEl = lb.querySelector("[data-slideshow]");
    const ss = ssEl ? getSlideshow(ssEl) : null;
    if (!ss) return;

    e.preventDefault();
    const idx = Number(item.dataset.idx) || 0;
    openLightbox(lb, ss, idx);
  };

  root.addEventListener("click", (e) => onActivate(e, e.target));
  root.addEventListener("keydown", (e) => {
    if (e.key !== "Enter" && e.key !== " ") return;
    if (!(e.target instanceof Element)) return;
    if (!e.target.classList.contains("masonry-item")) return;
    onActivate(e, e.target);
  });
}

function openLightbox(lb, ss, idx) {
  // Already open? just jump to index
  if (lb.classList.contains("is-open")) {
    ss.goTo(idx);
    return;
  }

  lb.classList.add("is-open");
  lb.setAttribute("aria-hidden", "false");
  document.body.classList.add("lightbox-open");

  const closeBtn = lb.querySelector(".lightbox-close");

  let closed = false;
  const close = () => {
    if (closed) return;
    closed = true;
    lb.classList.remove("is-open");
    lb.setAttribute("aria-hidden", "true");
    document.body.classList.remove("lightbox-open");
    ss.deactivate();
    closeBtn?.removeEventListener("click", onCloseClick);
    lb.removeEventListener("click", onBackdropClick);
    window.removeEventListener("keydown", onKey);
  };

  const onCloseClick = (ev) => { ev.preventDefault(); close(); };
  const onBackdropClick = (ev) => {
    // Close only when clicking the backdrop itself (not children)
    if (ev.target === lb) close();
  };
  const onKey = (ev) => {
    if (ev.key === "Escape") {
      ev.stopPropagation();
      close();
    }
  };

  closeBtn?.addEventListener("click", onCloseClick);
  lb.addEventListener("click", onBackdropClick);
  window.addEventListener("keydown", onKey, true);

  ss.goTo(idx);
  ss.activate();
}
